import styled, { createGlobalStyle } from 'styled-components'

import ContentBlockWrapper from '../../components/ContentBlockWrapper'

export const ContactContentWrapper = styled(ContentBlockWrapper)`
  padding: 20px 0 24px;
  background: transparent;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
`

export const TabContainer = styled.div`
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .ant-tabs-nav {
    margin-bottom: 0px;
  }
`

export const ContactPageHeading = styled.h1`
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  color: #0f172a;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  letter-spacing: -0.01em;
  margin: 0;
`

export const CompanySelectWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .company-prefix-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #70aefb;
    font-size: 15px;
    z-index: 2;
    pointer-events: none;
    transition: color 0.2s ease;
  }

  .ant-select {
    width: 340px;
    max-width: 100%;
    font-family: "Inter", Noto Sans Display, sans-serif !important;

    .ant-select-selector {
      height: 40px !important;
      padding: 0 32px 0 36px !important;
      border: 1px solid #e2e8f0 !important;
      border-radius: 8px !important;
      background: #ffffff !important;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
      transition: all 0.2s ease !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;

      &:hover {
        border-color: #bae6fd !important;
      }
    }

    &.ant-select-focused .ant-select-selector {
      border-color: #9cd4fc !important;
      box-shadow: 0 0 0 2px rgba(112, 174, 251, 0.18) !important;
    }

    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      line-height: 38px !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      color: #1e293b !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;
    }

    .ant-select-selection-placeholder {
      color: #94a3b8 !important;
      font-weight: 400 !important;
    }

    .ant-select-selection-search {
      left: 36px !important;
      right: 32px !important;

      .ant-select-selection-search-input {
        height: 38px !important;
        font-family: "Inter", Noto Sans Display, sans-serif !important;
      }
    }

    .ant-select-arrow {
      right: 14px;
      color: #64748b;
      font-size: 12px;
      transition: color 0.2s ease;
    }

    .ant-select-clear {
      right: 14px;
      background: #ffffff;
      color: #94a3b8;
      font-size: 12px;

      &:hover {
        color: #475569;
      }
    }
  }

  &:hover .company-prefix-icon {
    color: #70aefb;
  }
`

export const CompanySelectDropdownStyle = createGlobalStyle`
  .company-select-dropdown {
    border-radius: 8px !important;
    overflow: hidden !important;
    box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.1), 0 8px 10px -6px rgba(15, 23, 42, 0.05) !important;
    border: 1px solid #eef2f6 !important;
    padding: 4px !important;
    font-family: "Inter", Noto Sans Display, sans-serif !important;

    .ant-select-item {
      border-radius: 6px !important;
      padding: 8px 12px !important;
      font-size: 14px !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;
      transition: all 0.15s ease !important;

      &-option-selected {
        background-color: #eff8ff !important;
        color: #0f172a !important;
        font-weight: 600 !important;
      }

      &-option-active:not(.ant-select-item-option-selected) {
        background-color: #f8fafc !important;
        color: #0f172a !important;
      }
    }
  }
`

export const UserTabPanelContainer = styled.div``

export const TabPanelContainer = styled.div``
